import type { ServiceProcessStep } from '@bharat-consultancy/shared';

export function ProcessSteps({ steps }: { steps: ServiceProcessStep[] }) {
  if (steps.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {steps.map((step) => (
        <div key={step.id}>
          <span className="font-display text-3xl font-bold text-seal-blue/20">
            {String(step.stepNumber).padStart(2, '0')}
          </span>
          <h4 className="mt-1 font-display text-base font-semibold text-ink">{step.title}</h4>
          {step.description && <p className="mt-1.5 text-sm text-ink/60">{step.description}</p>}
        </div>
      ))}
    </div>
  );
}
